module.exports = __webpack_public_path__ + "store/img/icon_handheart@2x.d6b99c9b.png";